import React from 'react';
import type { Poll } from 'schema/poll';
import { ProgressLine } from './ProgressLine';
import { ProgressNumbers } from './ProgressNumbers';
import { ProgressPercent } from './ProgressPercent';
import { ProgressSegmentLine } from './ProgressSegmentLine';

interface ProgressProps {
  currentQuestionIndex: number;
  previousQuestionIndex: number;
  questionCount: number;
}

type ProgressBarType = Exclude<NonNullable<Poll['progressBar']>, 'invisible'>;

export interface ProgressBarProps extends ProgressProps {
  type: ProgressBarType;
}

const progressTypeToComponent: Record<ProgressBarType, React.ComponentType<ProgressProps>> = {
  numbers: ProgressNumbers,
  line: ProgressLine,
  segment_line: ProgressSegmentLine,
  percent: ProgressPercent,
};

export const ProgressBar = ({ type, ...props }: ProgressBarProps) => {
  const Progress = progressTypeToComponent[type];
  return <Progress {...props} />;
};
